var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"user-name",attrs:{"to":{ path: ("/u/" + (_vm.user.slug))},"tag":"span"},nativeOn:{"click":function($event){return _vm.clearTags()}}},[_vm._v(" "+_vm._s(this.user.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }